const memoryStorage = new Map();

function memoryGet(key) {
  return memoryStorage.has(String(key)) ? memoryStorage.get(String(key)) : null;
}

function memorySet(key, value) {
  memoryStorage.set(String(key), String(value));
}

function memoryRemove(key) {
  memoryStorage.delete(String(key));
}

export function isIOSWebKitBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function isIOSSafari() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const safari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  return isIOSWebKitBrowser() && safari;
}

export function installSafeStorageGuard() {
  if (typeof window === 'undefined' || typeof Storage === 'undefined') return;
  if (window.__ofisgorevSafeStorageInstalled) return;
  window.__ofisgorevSafeStorageInstalled = true;

  let nativeGet;
  let nativeSet;
  let nativeRemove;
  try {
    nativeGet = Storage.prototype.getItem;
    nativeSet = Storage.prototype.setItem;
    nativeRemove = Storage.prototype.removeItem;
  } catch {
    return;
  }

  Storage.prototype.getItem = function safeGetItem(key) {
    try {
      return nativeGet.call(this, key);
    } catch {
      return memoryGet(key);
    }
  };

  Storage.prototype.setItem = function safeSetItem(key, value) {
    try {
      nativeSet.call(this, key, value);
    } catch {
      memorySet(key, value);
    }
  };

  Storage.prototype.removeItem = function safeRemoveItem(key) {
    try {
      nativeRemove.call(this, key);
    } catch {
      memoryRemove(key);
    }
  };
}

export async function clearIOSServiceWorkerCaches() {
  if (!isIOSWebKitBrowser()) return;
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
  } catch {}
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.filter((key) => key.startsWith('ofisgorev-pwa-')).map((key) => caches.delete(key)));
    }
  } catch {}
}

// Geriye dönük uyumluluk için eski isim korunur.
export const clearSafariServiceWorkerCaches = clearIOSServiceWorkerCaches;
